import { hasPermission } from '../services/users/identity/user.service';
import { UserPermission } from '../enum/userPermissions';
import useSessionUser from './useSessionUser';

function usePermission(permission: UserPermission | UserPermission[]): boolean {
  const { user } = useSessionUser();
  return hasPermission(user, permission);
}

export { UserPermission } from '../enum/userPermissions';
export default usePermission;
